/** Muted track + raised white pill for org settings segmented choices. */
export const SEGMENT_TRACK_CLASS = "grid w-full gap-1 rounded-md border border-border bg-muted";
export const SEGMENT_ITEM_CLASS =
  "rounded-sm border border-transparent text-foreground hover:bg-background/60 hover:text-foreground data-[state=on]:border-border data-[state=on]:bg-background data-[state=on]:text-primary data-[state=on]:shadow-sm";

/**
 * Same look for `ToggleGroup variant="segmented"`: the white pill is the sliding thumb, so the
 * selected item stays transparent and only takes the primary label color.
 * `inset-y-1` assumes the track's `p-1`.
 */
export const SEGMENT_SLIDING_TRACK_CLASS = `${SEGMENT_TRACK_CLASS} shadow-none`;
export const SEGMENT_SLIDING_ITEM_CLASS =
  "rounded-sm border border-transparent text-foreground hover:bg-transparent hover:text-foreground data-[state=off]:hover:bg-background/60 data-[state=on]:text-primary motion-safe:active:scale-[0.97]";
export const SEGMENT_SLIDING_INDICATOR_CLASS =
  "inset-y-1 rounded-sm border border-border bg-background duration-300 ease-[cubic-bezier(0.25,1,0.5,1)]";
